class MainProductSelector extends ProductSelector {
  constructor() {
    super();

    this.selectors = {
      stickyATC: '[main-product-selector="sticky-atc"]',
      variantName: '[product="variant-string"]',
      scVariantName: '[product="variant-string-sc"]',
      sellingPlanInput: '[name="selling_plan"]',
      purchaseOption: '[name="purchase_option"]',
    };

    this.stickyATC = document.querySelector(this.selectors.stickyATC);

    this.variantName = document.querySelector(this.selectors.variantName);
    this.scVariantName = document.querySelector(this.selectors.scVariantName);
  }

  connectedCallback() {
    this.sellingPlanInput = this.querySelector(this.selectors.sellingPlanInput);

    window.addEventListener('selling-plan-change', (e) => {
      this.updateUnitPrices(e);
      super.updatePrice();
    });

    super.connectedCallback();

    this.updateUnitPrices();
    this.handleStickyATC();
  }

  /**
   * Handle sticky Add to cart.
   */
  handleStickyATC() {
    if (!this.stickyATC) {
      return;
    }

    this.stickyATC.style.setProperty(
      '--height',
      `${this.stickyATC.offsetHeight}px`,
    );

    const debouncedScrollHandler = debounce((event) => {
      this.scrollStickyATCHandler(event);
    }, 150);

    const quantityInput = this.stickyATC.querySelector('quantity-input input');
    const mainQuantityInput = this.querySelector('quantity-input input');

    document.addEventListener('scroll', debouncedScrollHandler);

    window.addEventListener('resize', (e) => {
      this.stickyATC.style.setProperty(
        '--height',
        `${this.stickyATC.offsetHeight}px`,
      );
    });

    if (quantityInput && mainQuantityInput) {
      quantityInput.addEventListener('change', () => {
        mainQuantityInput.value = quantityInput.value;
      });

      mainQuantityInput.addEventListener('change', () => {
        quantityInput.value = mainQuantityInput.value;
      });
    }
  }

  scrollStickyATCHandler(e) {
    if (!this.submitButtons[0]) {
      return;
    }

    this.stickyATC.classList.toggle('visible', this.showATC());
  }

  showATC() {
    return (
      !isElementInViewport(this.submitButtons[0]) &&
      window.scrollY >
        this.submitButtons[0].offsetTop + this.submitButtons[0].offsetHeight
    );
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);
    if (event.target.type === 'number' || !this.currentVariant) {
      return;
    }

    this.updateMedia();
    if (window.location.pathname.includes('/products/')) {
      this.updateURL();
    }

    this.updateVariantName();
  }

  /**
   * Update quantity options unit prices.
   *
   * @returns {Void}
   */
  updateUnitPrices() {
    const sellingPlanID =
      this.querySelector('[name="selling_plan"]')?.value || undefined;

    this.querySelectorAll('quantity-swatch').forEach((swatch) => {
      const optionIndex = swatch.getAttribute('data-option-index');
      const optionValue = swatch.getAttribute('data-option-value');

      const quantityVariant = this.variants.find((variant) => {
        return variant.options[optionIndex] == optionValue;
      });

      const price = sellingPlanID
        ? quantityVariant?.selling_plan_allocations?.find(
            (sellingPlan) => sellingPlan.selling_plan_id == sellingPlanID,
          ).price
        : quantityVariant?.price;

      swatch.updatePrice(price);
    });
  }

  updateVariantName() {
    if (!this.variantName || !this.currentVariant?.title) {
      return;
    }

    this.variantName.innerHTML = this.currentVariant?.title;
    
    if (!this.scVariantName || !this.currentVariant?.title) {
      return;
    }

    this.scVariantName.innerHTML = this.currentVariant?.title;
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
